import { isRunnableBridgePromptTurnServerState } from '@buildautomaton/types';
import type { PersistedPromptTurn } from '../disk-store.js';

export function pickNextRunnableTurn(turns: PersistedPromptTurn[]): PersistedPromptTurn | null {
  for (const t of turns) {
    if (t.bridgeServerState === 'discarded' || t.bridgeServerState === 'stopping') continue;
    if (t.bridgeServerState === 'cancel_requested') continue;
    if (!isRunnableBridgePromptTurnServerState(t.bridgeServerState)) continue;
    if (
      t.lastCliState === 'running' ||
      t.lastCliState === 'stopped' ||
      t.lastCliState === 'failed' ||
      t.lastCliState === 'cancelled'
    ) {
      continue;
    }
    return t;
  }
  return null;
}

export function hasRunningTurn(turns: PersistedPromptTurn[]): boolean {
  return turns.some((t) => t.lastCliState === 'running');
}
